import { Box, Tooltip } from '@mui/material';
import DatatypeInput from './Selector/FormController';
import { IMetadataJSON } from './Selector/types';
function RenderForm({ metadataArray, setMetadataArray, disabled = false }: {
  metadataArray: IMetadataJSON[],
  setMetadataArray?: any
  disabled?: boolean
}) {

  const handleOnSelect = (data: any, metadataEntry: any) => {
    const newMetadataArray = [...metadataArray];
    const index = newMetadataArray.findIndex((entry: any) =>
      entry.propertyName === metadataEntry.propertyName);
    newMetadataArray[index].propertyValue = data;
    setMetadataArray(newMetadataArray);
  };
  
  return (<>
    <Box display='flex' flexDirection='column'
      gap={5}>
      {metadataArray.map((metadataEntry, index) => {
        const { propertyName, propertyType, propertyValue, fieldIsRequired, } = metadataEntry;
        return <Box gap={5}
          key={index} display='flex'>
          {/* {index + 1}.  */}
          <DatatypeInput
            disabled={disabled}
            inputType={propertyType}
            width={150}
            value={propertyType === 'date'
              ? propertyValue || null
              : propertyValue}
            onSelect={(data) => handleOnSelect(data, metadataEntry)} label={<Box display='flex' flexDirection='row'>{propertyName}
              {fieldIsRequired && <Tooltip placement='top' title={'Αναγκαστικό πεδίο'}><div style={{ color: 'red' }}>*</div>
              </Tooltip>}
            </Box>
            }
          />
        </Box>;
      })}
    </Box>
  </>);
}

export default RenderForm;